import { Grid } from "@mui/material";

const _50_50 = ({ children, Pane = () => null, sx, hidePane = false }) => (
  <Grid container columns={10} sx={sx} pr={1}>
    <Grid size={{ compact: 10, large: hidePane ? 10 : 5 }}>{children}</Grid>
    <Grid size={{ compact: "grow", large: "grow" }}>
      <Pane />
    </Grid>
  </Grid>
);

export default _50_50;
